import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./plugins/router";
import store from "./plugins/store";
import masonry from "./plugins/masonry";
import vuetify from "./plugins/vuetify";
import draggable from 'vuedraggable';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
// import moment from 'moment';

// import our own components
import user_avatar from "@/components/user/user_avatar"
import alerts from '@/components/main/alerts';
import ok_cancel_dialog from '@/components/dialogs/ok_cancel_dialog';
import text_dialog from '@/components/dialogs/text_dialog';
import qrcode from "@/components/controls/qrcode";

Vue.config.productionTip = false;

Vue.component('v-draggable', draggable);
Vue.use(require('vue-moment'));
Vue.use(VueNumberInput);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

// register our components
Vue.component('v-user-avatar', user_avatar);
Vue.component('v-alerts', alerts);
Vue.component('v-ok-cancel', ok_cancel_dialog);
Vue.component('v-ask-question', text_dialog);
Vue.component('v-qrcode', qrcode);

// init document360 widget, https://portal.document360.io/5ef57f81-9ee0-40a5-ac52-71b71542b967/settings/knowledge-base-assistant
// if the apiKey changed, it needs to change
/*
if (window.innerWidth >= 700) {
	(function (w,d,s,o,f,js,fjs) {
		w['JS-Widget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
		js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
		js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
	}(window, document, 'script', 'mw', 'https://cdn.document360.io/static/js/widget.js'));
	mw('init', { apiKey: 'E7AK9Qil+ZDLZnjm8ZiRI90EMaz+oHKhYvbhK5RUa5DoVn+0fkHnprHubfkzYn7+pJC3OXbEzBKqWGTWT/x77QU14XcaAS7J1PV/xkp/bkChAYc6akRcMZkozcEUt8HFnafEYRumYFDJaJ+ZEu/53w==' });	
}
*/

// init Help Scout Beacon, https://secure.helpscout.net/settings/docs/beacon/67f7612a902520669836e7d7
// if the apiKey changed, it needs to change
if (window.innerWidth >= 700) {
	!function(e,t,n){
		function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");
		n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();
		e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)
	}(window,document,window.Beacon||function(){});
	window.Beacon('init', 'd3e5008d-babf-4241-a361-6f81173db6eb') 
}

new Vue({
	router,
	store,
	masonry,
	vuetify,
	render: h => h(App)
}).$mount("#app");
